export const personData2021 = [
  {
    name: '段昊泓',
    pic: 'https://img.meituan.net/gongyimobile/b9e176d87150d67710217b51fa307ac2633035.png',
    subject: '化学',
    organization: '清华大学',
    issue: '绿色低碳包装材料',
    reason: '段昊泓在含碳废弃物电化学处置，和废塑料、生物质与水耦合电解制氢方面取得突出贡献。未来他将继续探索废弃物绿色高价值利用方法。',
    year: '2021',
  },
  {
    name: '郭凯',
    pic: 'https://img.meituan.net/gongyimobile/bcda6ac8fa5c99f0866a41883a038276266085.png',
    subject: '化学工程',
    organization: '南京工业大学',
    issue: '绿色低碳包装材料',
    reason: '郭凯在绿色低碳化工生产，特别是微流场技术生产生物材料方面做出重要贡献。未来他将推动关键生物原料的大规模安全、绿色生产。',
    year: '2021',
  },
  {
    name: '郭玉国',
    pic: 'https://img.meituan.net/gongyimobile/c4eac5180cf1fa6ea9b4ed0b7f9b32bb346824.png',
    subject: '能源科学技术',
    organization: '中国科学院化学研究所',
    issue: '低碳运输及储能',
    reason: '郭玉国在高性能电池材料设计|基础理论研究及新材料研发方面做出重要贡献。未来他将推动新能源车及储能用固态电池技术研究落地。',
    year: '2021',
  },
  {
    name: '李先锋',
    pic: 'https://img.meituan.net/gongyimobile/18f2ece92f529e83368bc43e77498e34402946.png',
    subject: '能源科学技术',
    organization: '中国科学院大连化学物理研究所',
    issue: '低碳运输及储能',
    reason: '李先锋对电池储能研究和超大规模的高性能液流电池储能技术应用突破做出重要贡献。未来他将推动新能源电力系统储能装备技术进步。',
    year: '2021',
  },
  {
    name: '王润国',
    pic: 'https://img.meituan.net/gongyimobile/ade19f6b00fdc2cd20d11e7134427f67279901.png',
    subject: '材料科学',
    organization: '北京化工大学',
    issue: '低碳运输及储能',
    reason: '王润国在生物基弹性体研究和推动新型橡胶规模化生产方面做出重要贡献。未来他将探索发掘更多可产业化应用的绿色低碳弹性体。',
    year: '2021',
  },
  {
    name: '王双印',
    pic: 'https://img.meituan.net/gongyimobile/2376989c92e7508dc9f63596fddebbce363415.png',
    subject: '化学',
    organization: '湖南大学',
    issue: '碳捕集及资源化利用',
    reason: '王双印在电催化与电合成研究，二氧化碳制备尿素等绿色固碳技术开发方面取得突出成果。未来他将推动二氧化碳的高效电催化转化研究。',
    year: '2021',
  },
  {
    name: '王钻开',
    pic: 'https://img.meituan.net/gongyimobile/0d26ef08b43387b853b56483106ed4ee395419.png',
    subject: '前沿交叉',
    organization: '香港理工大学',
    issue: '低碳运输及储能',
    reason: '王钻开在表面科学研究，及开发有节能潜力的微纳涂层材料制备技术方面做出重要贡献。未来他将继续推动多功能先进涂层材料产业化应用。',
    year: '2021',
  },
  {
    name: '温宗国',
    pic: 'https://img.meituan.net/gongyimobile/d5178fb7bc3f1815a04aa1facbbc32d9438224.png',
    subject: '环境科学技术',
    organization: '清华大学',
    issue: '绿色低碳包装材料',
    reason: '温宗国在固废资源化与碳排放系统工程过程机理、关键研究方法方面做出重要贡献。未来他将推动塑料等固废精准探测及智能化材料分选研究。',
    year: '2021',
  },
  {
    name: '邢华斌',
    pic: 'https://img.meituan.net/gongyimobile/2794adbb928797800bb74fb4d3019aef371092.png',
    subject: '化学工程',
    organization: '浙江大学',
    issue: '碳捕集及资源化利用',
    reason: '邢华斌在低能耗气体分离技术研究和含碳分子超高选择性分离材料开发方面取得突出成果。未来他将投入高性能碳捕集技术开发。',
    year: '2021',
  },
];

export const personData2022 = [
  {
    name: '鲍宗必',
    pic: 'https://img.meituan.net/gongyimobile/b350974be3c80f973b84755fb5a0b7032234093.png',
    subject: '化学工程',
    organization: '浙江大学',
    issue: '碳捕集及资源化利用',
    reason: '鲍宗必深耕高性能吸附分离材料的设计构建，研究成果实现产业化。未来，他致力于探索更多难分离化工产品的高性能吸附分离材料及技术。',
    year: '2022',
  },
  {
    name: '程道建',
    pic: 'https://img.meituan.net/gongyimobile/49590383a33099d653ebf293f5072a392366504.png',
    subject: '化学工程',
    organization: '北京化工大学',
    issue: '新能源及储能',
    reason: '程道建聚焦金属纳米催化剂在电解水制氢、燃料电池等新能源领域的应用，取得突出成果。未来，他将探索低成本高效质子交换膜电解水制氢催化剂的设计与制造。',
    year: '2022',
  },
  {
    name: '黄延强',
    pic: 'https://img.meituan.net/gongyimobile/898d061da4a8f1a6d8dd55e85631eef55219335.png',
    subject: '化学工程',
    organization: '中国科学院大连化学物理研究所',
    issue: '碳捕集及资源化利用',
    reason: '黄延强针对载人航天用二氧化碳甲烷化催化剂和装置开展研究，取得突出成果。未来，他将深入挖掘二氧化碳催化剂机理并推动实现量产和工程应用。',
    year: '2022',
  },
  {
    name: '李建荣',
    pic: 'https://img.meituan.net/gongyimobile/485d2c9b8a86139f8b0898508282a3e74238125.png',
    subject: '化学',
    organization: '北京工业大学',
    issue: '碳捕集及资源化利用',
    reason: '李建荣致力于金属有机框架材料应用基础研究，取得系列创新成果。未来，他将探索高性能新型吸附剂靶向创制及其在碳捕集、高危污染物痕量去除方面的应用。',
    year: '2022',
  },
  {
    name: '李丽',
    pic: 'https://img.meituan.net/gongyimobile/1b2a07777625c0a34622fffed4dc92da1594735.png',
    subject: '环境科学技术',
    organization: '北京理工大学',
    issue: '绿色低碳材料',
    reason: '李丽突破了锂离子电池绿色高效回收及可降解材料源头设计关键技术，并实现成果转化应用。未来她致力于构筑绿色电池新体系，探索退役电池绿色闭环回收、原位修复及资源循环利用等新技术。',
    year: '2022',
  },
  {
    name: '刘龙',
    pic: 'https://img.meituan.net/gongyimobile/9c9ac40fecab2dcd80acda49c2540ff33888366.png',
    subject: '前沿交叉',
    organization: '江南大学',
    issue: '碳捕集及资源化利用',
    reason: '刘龙从事合成生物学与食品生物制造的基础理论、关键技术与工程应用研究，取得突出成果。未来，他将探索利用C1原料实现乳铁蛋白等系列乳源功能蛋白的绿色和高效生物制造。',
    year: '2022',
  },
  {
    name: '马骧',
    pic: 'https://img.meituan.net/gongyimobile/7806ed370ddaf94a149b2a99ae34d5732129006.png',
    subject: '材料科学',
    organization: '华东理工大学',
    issue: '绿色低碳材料',
    reason: '马骧深耕高值化功能染料研究，发明绿色清洁的有机室温磷光染料产品体系，研究成果突出。未来他致力于构建可调控有机功能染料的材料库，并推广有机室温磷光染料及相关智能光功能材料的市场应用，实现材料的低碳制造。',
    year: '2022',
  },
  {
    name: '王琛',
    pic: 'https://img.meituan.net/gongyimobile/a561e99ebdd0a2f1a37ecab7806b3d7c2551840.png',
    subject: '前沿交叉',
    organization: '清华大学',
    issue: '新能源及储能',
    reason: '王琛聚焦后摩尔芯片多层级系统化研究，通过原创新材料与多技术融合创新，在综合环境感知芯片领域取得突破。未来，他将从集成多模式和芯片智能化等方面推动其在新能源与储能安全、低碳环境立体监测等领域的产业应用。',
    year: '2022',
  },
  {
    name: '余彦',
    pic: 'https://img.meituan.net/gongyimobile/0e607b29a4682410d5cceb456cd311c53489119.png',
    subject: '能源科学技术',
    organization: '中国科学技术大学',
    issue: '新能源及储能',
    reason: '余彦围绕钠离子电池关键电极材料及储能机制开展研究，取得突出成果。未来，她将致力于研究高比能、长寿命、低成本的新型钠离子电池储能材料及系统。',
    year: '2022',
  },
  {
    name: '邹如强',
    pic: 'https://img.meituan.net/gongyimobile/4f2ba5a0f06e1399fcfb109cbc3b569a4521449.png',
    subject: '材料科学',
    organization: '北京大学',
    issue: '新能源及储能',
    reason: '邹如强围绕多孔材料在新能源领域的应用开展系列研究，取得突出成果。未来，他将致力于研究多孔材料在电化学能源存储与转化、相变热管理等领域的应用。',
    year: '2022',
  },
];

export const personData2023 = [
  {
    name: '白志山',
    pic: 'https://img.meituan.net/gongyimobile/c8351c3b91bfc6c647b77d6c4ad69eaf1213603.png',
    subject: '化学工程',
    organization: '华东理工大学',
    issue: '降碳减污协同控制',
    reason: '白志山围绕液滴振荡破乳分离开展研究，联合中国石化开发成功国内首套具有自主知识产权的硫酸烷基化工艺，打破国外垄断。未来将探索绿色高效的分离理论和相应技术体系。',
    year: '2023',
  },
  {
    name: '程群峰',
    pic: 'https://img.meituan.net/gongyimobile/841066405981d6be0fa7237647ba95c41498802.png',
    subject: '材料科学',
    organization: '北京航空航天大学',
    issue: '绿色低碳材料',
    reason: '程群峰致力于高性能纳米复合材料和仿生材料的设计与构筑，取得突出成果，未来将推动新型仿生材料设计和绿色低碳制造研究。',
    year: '2023',
  },
  {
    name: '邓德会',
    pic: 'https://img.meituan.net/gongyimobile/1262edf08a07732e7bc9f7e3416551401922088.png',
    subject: '能源科学技术',
    organization: '中国科学院大连化学物理研究所',
    issue: '碳捕集及资源化利用',
    reason: '邓德会聚焦能源与环境小分子催化转化方面的基础科学与工业应用研究，成果实现落地转化。未来将继续探索碳一、水等小分子低碳高效催化转化的新过程与规模化应用新技术。',
    year: '2023',
  },
  {
    name: '郭少军',
    pic: 'https://img.meituan.net/gongyimobile/2a27c8e9c1bbb8614530b1e2d590fb4a1581345.png',
    subject: '前沿交叉',
    organization: '北京大学',
    issue: '新能源及储能',
    reason: '郭少军围绕氢电能源转化新材料、化学机制和器件开展研究，取得突出成果。未来将致力于探索高性能低贵金属催化剂与氢能膜电极制备新技术。',
    year: '2023',
  },
  {
    name: '鲁玺',
    pic: 'https://img.meituan.net/gongyimobile/693868279a09902726fe9f0f4af17b701380473.png',
    subject: '环境科学技术',
    organization: '清华大学',
    issue: '降碳减污协同控制',
    reason: '鲁玺围绕碳中和背景下可再生能源系统的综合环境效应开展研究，取得突出成果。未来将探索基于可再生能源倍增式发展的"电-氢-碳"耦合系统减污降碳效应研究并推动结果落地示范。',
    year: '2023',
  },
  {
    name: '王博',
    pic: 'https://img.meituan.net/gongyimobile/a35967cb95de46a95f3d55c42936c6dc1433064.png',
    subject: '化学',
    organization: '北京理工大学',
    issue: '碳捕集及资源化利用',
    reason: '王博致力于分子仿生开放框架材料的设计与构筑，聚焦分子选择性捕捉、传输与催化研究。聚焦二氧化碳、氢气等的分离与转化，取得突出成果。未来将推动二氧化碳大规模转化、绿氢大规模制备利用的技术突破。',
    year: '2023',
  },
  {
    name: '王勇',
    pic: 'https://img.meituan.net/gongyimobile/28b303f25e90405a0a39a815da1305f81307859.png',
    subject: '化学',
    organization: '浙江大学',
    issue: '降碳减污协同控制',
    reason: '王勇围绕催化选择性加氢开展了系统的研究，开发了系列绿色、高效的化学生产过程，成果实现落地转化。未来将深入探索更精细化的工业催化过程，并探究其科学原理。',
    year: '2023',
  },
  {
    name: '杨鹏',
    pic: 'https://img.meituan.net/gongyimobile/4e86091faa95cdb76061791faf95dedd1511248.png',
    subject: '材料科学',
    organization: '陕西师范大学',
    issue: '绿色低碳材料',
    reason: '杨鹏聚焦生物相容和环境友好的蛋白质材料研究，成果实现落地转化。未来将致力于构建蛋白质基低碳材料体系，推动该类材料在生物农药、食品保鲜和绿色包装等方面的可持续应用。',
    year: '2023',
  },
  {
    name: '赵一新',
    pic: 'https://img.meituan.net/gongyimobile/ad3dcbf43bd14827aec9d1dad39b14631396208.png',
    subject: '能源科学技术',
    organization: '上海交通大学',
    issue: '新能源及储能',
    reason: '赵一新聚焦高效稳定钙钛矿光伏的绿色、可控和稳定制造，取得突出成果。未来他致力于推动钙钛矿-晶硅叠层光伏的设计、规模制造，突破单一类别光伏效率上限。',
    year: '2023',
  },
  {
    name: '仲兆祥',
    pic: 'https://img.meituan.net/gongyimobile/71554587accd4059eb3232b068394a2f1629447.png',
    subject: '化学工程',
    organization: '南京工业大学',
    issue: '降碳减污协同控制',
    reason: '仲兆祥聚焦工业烟气净化处理研究，发明高能效微纳粉尘净化膜，成果实现落地转化。未来将继续推动多功能膜技术在减污降碳协同治理领域的应用。',
    year: '2023',
  },
];

export const personData2024 = [
  {
    name: '陈棋',
    pic: 'https://img.meituan.net/gongyimobile/de08385606bcabbc09e83035e460d41712289914.png',
    subject: '能源科学技术',
    organization: '北京理工大学',
    issue: '新能源及储能',
    reason: '陈棋系统研究新型薄膜光伏材料与器件可规模制备的关键科学问题，取得突出成果。未来将聚焦下一代光伏技术产业化的共性核心挑战进行深入探索。',
    year: '2024',
  },
  {
    name: '郭孝东',
    pic: 'https://img.meituan.net/gongyimobile/af416a0d952f094f055bc82d4bc543f72228889.png',
    subject: '前沿交叉',
    organization: '四川大学',
    issue: '绿色低碳材料',
    reason: '郭孝东围绕二次电池关键材料结构调控及放大制备展开研究，成果实现落地转化。未来将致力于开发高能量密度、高安全超高镍固态电池，推动储能技术高质量发展。',
    year: '2024',
  },
  {
    name: '何宏艳',
    pic: 'https://img.meituan.net/gongyimobile/ca71b25c6fd5a2e7587b3d9a5fdb926c4985064.png',
    subject: '化学工程',
    organization: '中国科学院过程工程研究所',
    issue: '碳捕集及资源化利用',
    reason: '何宏艳致力于绿色介质离子液体的基础及应用研究，取得突出成果。未来将继续探索高性能限域离子液体功能材料的创制及其在碳捕集、湿气发电等领域的应用。',
    year: '2024',
  },
  {
    name: '李辉',
    pic: 'https://img.meituan.net/gongyimobile/4fb99154f4c14f588b6780672a7ea690476044.png',
    subject: '环境科学技术',
    organization: '上海大学',
    issue: '降碳减污协同控制',
    reason: '李辉围绕土壤污染与低碳修复治理关键科学技术问题，取得突出成果，实现落地转化。未来将探索污染场地污染智慧预警-刻画溯源-精准防控-协同修复综合防治研究。',
    year: '2024',
  },
  {
    name: '陶新永',
    pic: 'https://img.meituan.net/gongyimobile/cc49b25c8e6b162feed5d441564d5a311261649.png',
    subject: '能源科学技术',
    organization: '浙江工业大学',
    issue: '新能源及储能',
    reason: '陶新永聚焦高比能锂二次电池材料基础理论及应用研究，在敏感电池材料微尺度构效关系研究领域取得突出成果，实现落地转化。未来将致力于探索全固态锂电池材料和界面调控新技术。',
    year: '2024',
  },
  {
    name: '王朝',
    pic: 'https://img.meituan.net/gongyimobile/5ecd7078edb81b7d8bbbd3fbf4e91dcc7231300.png',
    subject: '材料科学',
    organization: '华南理工大学',
    issue: '绿色低碳材料',
    reason: '王朝围绕生物基可降解合成橡胶基础及工程化展开研究，取得突出成果，并实现落地转化。未来将持续推动生物基可降解橡胶的科学研究和工程转化，解决轮胎磨屑等废弃橡胶污染的世界难题。',
    year: '2024',
  },
  {
    name: '徐建鸿',
    pic: 'https://img.meituan.net/gongyimobile/3f73f186cddd68383a4a5103af2475d41170909.png',
    subject: '化学工程',
    organization: '清华大学',
    issue: '降碳减污协同控制',
    reason: '徐建鸿聚焦微化工新技术研究，发明新型微反应器和模块化微化工系统，成果实现落地转化。未来将深入探索高效安全连续合成新技术。',
    year: '2024',
  },
  {
    name: '曾杰',
    pic: 'https://img.meituan.net/gongyimobile/494bdb80d0e0e7d7d701700f1e04e29b1339900.png',
    subject: '化学',
    organization: '安徽工业大学/中国科学技术大学',
    issue: '碳捕集及资源化利用',
    reason: '曾杰在原子分子层面揭示二氧化碳催化转化的反应机制，提出动态限域催化剂设计理念，实现高稳定性催化剂的创制，开辟出电-生耦合催化新过程，实现以二氧化碳和水制备葡萄糖和脂肪酸等食品分子。未来将探索利用二氧化碳合成复杂天然分子的催化转化新技术。',
    year: '2024',
  },
  {
    name: '赵亮',
    pic: 'https://img.meituan.net/gongyimobile/6fb7050320d2fd19fbaa08fc5eb5c84f594412.png',
    subject: '化学工程',
    organization: '中国石油大学（北京）',
    issue: '降碳减污协同控制',
    reason: '赵亮围绕油气清洁化和油品转化学品开展以精准分离与定向转化为核心的研究工作，成果实现落地转化。未来将继续致力于绿电驱动下分子炼油技术的开发与应用。',
    year: '2024',
  },
  {
    name: '朱嘉',
    pic: 'https://img.meituan.net/gongyimobile/bbd279764e1a354a0d8a696c94935aa61190978.png',
    subject: '前沿交叉',
    organization: '南京大学',
    issue: '新能源及储能',
    reason: '朱嘉围绕光热调控的微纳结构、化学机制和器件制备开展研究，取得突出成果，并实现落地转化。未来将致力于极端尺度光热调控机制和极端条件下的光热调控应用方面的研究。',
    year: '2024',
  },
];

export const personData2025 = [
  {
    name: '陈一彤',
    pic: 'https://img.meituan.net/gongyimobile/b1243f1c68bd7e8f73327d52506811f0276775.png',
    subject: '交叉学科',
    organization: '上海交通大学',
    issue: '降碳减污协同控制',
    reason: '陈一彤聚焦高速超低功耗光电智能计算芯片展开研究，提出光芯片架构ACCEL和LightGen，国际首次实现大规模全光语义高分辨率图像、视频生成，显著提升计算算力能效。未来将持续推进新一代光电智能算力工程转化，助力绿色AI技术发展。',
    year: '2025',
  },
  {
    name: '董焕丽',
    pic: 'https://img.meituan.net/gongyimobile/10412d304cb30b427750b6b732226202797873.png',
    subject: '材料科学',
    organization: '中国科学院化学研究所',
    issue: '绿色低碳材料',
    reason: '董焕丽聚焦驱动发光一体化显示关键材料与器件开展研究，为绿色低能耗新型显示技术研究提供了新的解决方案。未来将致力于超低能耗驱动发光一体化类脑显示的基础应用研究，突破传统多器件物理连接集成显示的效能上限。',
    year: '2025',
  },
  {
    name: '姜雪峰',
    pic: 'https://img.meituan.net/gongyimobile/097cd9e2d816574f9b417de3ff63de701293716.png',
    subject: '化学',
    organization: '华东师范大学',
    issue: '碳捕集及资源化利用',
    reason: '姜雪峰建立3S绿色硫化学体系，实现数量态与氧化态的硫精准控制，突破硫恶臭、强毒化、低兼容瓶颈问题。未来将聚焦硫化学硫化工系统产业化导向研究，推动人工智能绿色合成化学发展。',
    year: '2025',
  },
  {
    name: '兰华春',
    pic: 'https://img.meituan.net/gongyimobile/5fdf71307e3055c5168aa00bb1046ded962019.png',
    subject: '环境科学',
    organization: '清华大学',
    issue: '降碳减污协同控制',
    reason: '兰华春聚焦水中重（类）金属的价态和形态调控，开发出关键药剂、装备和适配工艺，实现工业废水低耗高效深度处理与资源化利用。未来将聚焦水/固介质中稀贵金属等的回收开展应用基础研究和工程应用研究。',
    year: '2025',
  },
  {
    name: '雷振东',
    pic: 'https://img.meituan.net/gongyimobile/56ec2fc248994caf6195cb88a84793f81077024.png',
    subject: '环境科学',
    organization: '同济大学',
    issue: '降碳减污协同控制',
    reason: '雷振东围绕碳基纳米材料创制及其在能源与环境中的应用开展研究，提升污染治理效率并促进资源回收利用，推动相关技术在养殖废弃物等场景的工程示范与转化应用。未来将持续探索低能耗、低碳排放的污染治理与资源化闭环新技术。',
    year: '2025',
  },
  {
    name: '刘岗',
    pic: 'https://img.meituan.net/gongyimobile/cd9f9c8f66e938df7a02a09ea82013321172687.png',
    subject: '材料科学',
    organization: '中国科学院金属研究所',
    issue: '新能源及储能',
    reason: '刘岗聚焦太阳能与氢能材料研究，在半导体光催化材料多尺度有序化方面取得了系列创新性成果，推动了高效解水制氢技术的发展。未来将致力于太阳能解水制氢与资源增值转化耦合系统研究。',
    year: '2025',
  },
  {
    name: '杨贵东',
    pic: 'https://img.meituan.net/gongyimobile/0ad2e1f683cd753c15233cb22065f89b986008.png',
    subject: '化学工程',
    organization: '西安交通大学',
    issue: '新能源及储能',
    reason: '杨贵东聚焦空气-水合成绿氨新方向，从源头重构绿氨合成路径，实现低能耗、低碳排放的氨生产。未来将推动绿氨合成的工业化进程，助力绿氨合成新兴产业的快速形成。',
    year: '2025',
  },
  {
    name: '杨四海',
    pic: 'https://img.meituan.net/gongyimobile/822fc3f34e15dd14fdf5d5e0cc5f181a736597.png',
    subject: '化学',
    organization: '北京大学',
    issue: '碳捕集及资源化利用',
    reason: '杨四海聚焦多孔材料的化学调控，发展中子散射-吸附催化联用技术，推动该技术在气体污染物捕集、废弃资源转化中的应用。未来将继续探索"变废为宝"的关键材料体系和绿色新技术。',
    year: '2025',
  },
  {
    name: '张会岩',
    pic: 'https://img.meituan.net/gongyimobile/fe476cb2ebb2f27668016ead75a5bfa2995960.png',
    subject: '能源科学',
    organization: '东南大学',
    issue: '降碳减污协同控制',
    reason: '张会岩围绕有机固废高值化利用，开发定向热解短流程一体化关键技术与装备，实现有机固废的分质高效转化。未来将持续开展可再生能源驱动下的有机固废制备生物航油和炭材料科学研究与工程应用。',
    year: '2025',
  },
  {
    name: '张如范',
    pic: 'https://img.meituan.net/gongyimobile/c1ceb4dcfeadfcdb0a29a44f85641822387048.png',
    subject: '能源科学',
    organization: '清华大学',
    issue: '绿色低碳材料',
    reason: '张如范围绕高性能光热调控材料开展结构设计、作用机制与规模应用等的系统研究，有效降低建筑、汽车及人体热管理领域的能耗需求。未来将持续探索低能耗、低碳排放的制冷与节能新技术。',
    year: '2025',
  },
];
